import { assertScopedProjectSlug } from "./url-scope-CRM5sNo7.js";

//#region src/internal/tool-helpers/issue.ts
function assertIssueWithinProjectConstraint({ issue, projectSlug, resourceLabel = "Issue" }) {
	assertScopedProjectSlug({
		resourceLabel,
		scopedProjectSlug: projectSlug,
		actualProjectSlug: issue.project.slug
	});
}
async function ensureIssueWithinProjectConstraint({ apiService, organizationSlug, issueId, projectSlug, resourceLabel = "Issue" }) {
	if (!projectSlug) return;
	const issue = await apiService.getIssue({
		organizationSlug,
		issueId
	});
	assertIssueWithinProjectConstraint({
		issue,
		projectSlug,
		resourceLabel
	});
}

//#endregion
export { assertIssueWithinProjectConstraint, ensureIssueWithinProjectConstraint };
//# sourceMappingURL=issue-D65xI0F7.js.map